import { TranslationDictionary } from '../types';

export const de: TranslationDictionary = {
  'ots.seat_entry.hint': 'Bitte geben Sie Ihre Sitzplatznummer ein, um fortzufahren.',
  'ots.seat_entry.seat_number': 'Sitzplatznummer',
  'ots.seat_entry.placeholder': 'z. B. A12',
  'ots.seat_entry.continue': 'Weiter',
  'ots.qr_entry.hint': 'Scannen Sie den QR-Code an Ihrem Platz, um zu starten.',
  'ots.fulfillment.back': 'Zurück',
  'ots.fulfillment.title': 'Wie möchten Sie Ihre Bestellung?',
  'ots.fulfillment.seat': 'Platz',
  'ots.fulfillment.table': 'Tisch',
  'ots.fulfillment.delivery_seat.title': 'Lieferung an den Platz',
  'ots.fulfillment.delivery_table.title': 'Lieferung an den Tisch',
  'ots.fulfillment.delivery.hint': 'Das Personal bringt sie zu Ihnen',
  'ots.fulfillment.delivery.fee': '+[[amount]] Servicegebühr',
  'ots.fulfillment.pickup.title': 'Selbstabholung',
  'ots.fulfillment.pickup.hint': 'Abholung an der Concession-Theke',
  'ots.fulfillment.pickup.fee': 'Keine Servicegebühr',
  'ots.fulfillment.browse': 'Zur Speisekarte',
  'ots.menu.back': 'Zurück',
  'ots.menu.search': 'Suchen',
  'ots.menu.search_placeholder': 'Speisekarte durchsuchen',
  'ots.menu.view_cart': 'Warenkorb anzeigen',
  'ots.menu.delivery': 'Lieferung',
  'ots.menu.add': 'Hinzufügen',
  'ots.menu.remove': 'Entfernen',
  'ots.menu.tab.all': 'Alle',
  'ots.menu.tab.popcorn': 'Popcorn',
  'ots.menu.tab.drinks': 'Getränke',
  'ots.menu.tab.snacks': 'Snacks',
  'ots.menu.tab.sweets': 'Süßes',
  'ots.menu.section.beer': 'Bier',
  'ots.menu.section.popcorn': 'Popcorn',
  'ots.menu.section.long-drinks': 'Longdrinks',
  'ots.menu.section.wine': 'Wein',
  'ots.menu.section.cocktails': 'Cocktails',
  'ots.menu.section.soft-drinks': 'Erfrischungsgetränke',
  'ots.menu.section.hot-drinks': 'Heißgetränke',
  'ots.menu.section.snacks': 'Snacks',
  'ots.menu.section.sweets': 'Süßes',
  'ots.menu.item.beer-pils': 'Pils',
  'ots.menu.item.popcorn-sweet': 'Süßes Popcorn',
  'ots.menu.item.wine-white': 'Weißwein',
  'ots.menu.item.wine-red': 'Rotwein',
  'ots.menu.item.wine-green': 'Grüner Wein',
  'ots.menu.item.wine-prosecco': 'Prosecco',
  'ots.menu.item.cola': 'Cola',
  'ots.menu.item.nachos': 'Nachos',
  'ots.menu.item.m-and-m': 'M&M',
  'ots.cart.title': 'Ihre Bestellung',
  'ots.cart.close': 'Schließen',
  'ots.cart.checkout': 'Zur Kasse',
  'ots.checkout.back': 'Zurück',
  'ots.checkout.title': 'Kasse',
  'ots.checkout.summary': 'Bestellübersicht',
  'ots.checkout.line': '[[qty]]x [[name]]',
  'ots.checkout.subtotal': 'Zwischensumme',
  'ots.checkout.service_fee': 'Servicegebühr',
  'ots.checkout.total': 'Gesamt',
  'ots.checkout.delivered_seat': 'Lieferung an Ihren Platz',
  'ots.checkout.delivered_table': 'Lieferung an Ihren Tisch',
  'ots.checkout.pickup_counter': 'Abholung an der Theke',
  'ots.checkout.details': 'Ihre Angaben',
  'ots.checkout.name': 'Ihr Name',
  'ots.checkout.name_placeholder': 'Sarah Mitchell',
  'ots.checkout.payment': 'Zahlung',
  'ots.checkout.payment.paypal': 'PayPal',
  'ots.checkout.payment.apple_pay': 'Apple Pay',
  'ots.checkout.payment.credit_card': 'Kreditkarte',
  'ots.checkout.payment.google_pay': 'Google Pay',
  'ots.checkout.pay': '[[amount]] bezahlen',
  'ots.confirm.title': 'Bestellung bestätigt!',
  'ots.confirm.hint': 'Ihre Bestellung ist jetzt beim Kinoteam.',
  'ots.confirm.order': 'Bestellung',
  'ots.confirm.eta.delivery': 'Geschätzt: 15–20 Min.',
  'ots.confirm.eta.pickup': 'Geschätzt: 10 Min.',
  'ots.confirm.eta.ready_pickup': 'Bereit zur Abholung',
  'ots.confirm.eta.ready_delivery': 'Unterwegs zu Ihrem Platz',
  'ots.confirm.step.received': 'Bestellung eingegangen',
  'ots.confirm.step.preparing': 'Ihre Bestellung wird zubereitet',
  'ots.confirm.step.on_the_way': 'Unterwegs zu Ihrem Platz',
  'ots.confirm.step.ready': 'Bereit zur Abholung',
  'ots.confirm.total_paid': 'Bezahlt',
  'ots.confirm.new_order': 'Neue Bestellung starten',
  'ots.staff.title': 'Personal-Dashboard',
  'ots.staff.total': '[[count]] Bestellungen insgesamt',
  'ots.staff.total.one': '[[count]] Bestellung insgesamt',
  'ots.staff.search': 'Suchen',
  'ots.staff.search_placeholder': 'Hier eingeben',
  'ots.staff.search_submit': 'Suchen',
  'ots.staff.filters': 'Filter',
  'ots.staff.filters.status': 'Status',
  'ots.staff.column': '[[label]] ([[count]])',
  'ots.staff.column.new': 'NEU',
  'ots.staff.column.preparing': 'IN ZUBEREITUNG',
  'ots.staff.column.ready': 'BEREIT ZUR AUSLIEFERUNG',
  'ots.staff.column.done': 'FERTIG',
  'ots.staff.status.new': 'Neu',
  'ots.staff.status.preparing': 'In Zubereitung',
  'ots.staff.status.ready': 'Bereit zur Auslieferung',
  'ots.staff.status.ready_pickup': 'Bereit zur Abholung',
  'ots.staff.status.done': 'Fertig',
  'ots.staff.meta': 'vor [[minutes]] Min. · [[name]]',
  'ots.staff.meta.now': 'Gerade eben · [[name]]',
  'ots.staff.line': '[[qty]]× [[name]]',
  'ots.staff.fulfillment.pickup': 'Abholung',
  'ots.staff.action.prepare': 'Zubereitung starten',
  'ots.staff.action.ready': 'Bereit zur Auslieferung',
  'ots.staff.action.ready_pickup': 'Bereit zur Abholung',
  'ots.staff.action.delivered': 'Als ausgeliefert markieren',
  'ots.staff.action.received': 'Als abgeholt markieren',
  'ots.staff.completed': 'Abgeschlossen',
  'ots.staff.item.popcorn_butter_large': 'Butter-Popcorn (groß)',
  'ots.staff.item.smash_burger': 'Smash Burger'
};
